<template>
  <div class="icons">
    <div class="forcast-icon-wrapper">
      <img v-if="bigEye === 1" src="@/assets/svg/chart-icons/player-outline.svg" alt="Big eye forcast" />
      <img v-if="bigEye === 0" src="@/assets/svg/chart-icons/banker-outline.svg" alt="Banker count" />
    </div>
    <div class="forcast-icon-wrapper">
      <img v-if="smallRoad === 1" src="@/assets/svg/chart-icons/player-filled.svg" alt="Small road forcast" />
      <img v-if="smallRoad === 0" src="@/assets/svg/chart-icons/banker-filled.svg" alt="Banker count" />
    </div>
    <div class="forcast-icon-wrapper">
      <img v-if="cockroachRoad === 1" src="@/assets/svg/chart-icons/player-line.svg" alt="Cockroach Road forcast" />
      <img v-if="cockroachRoad === 0" src="@/assets/svg/chart-icons/banker-line.svg" alt="Banker count" />
    </div>
  </div>
</template>
<script>
import PlayerOutline from '@/assets/svg/chart-icons/player-outline.svg';

export default {
  props: {
    bigEye: {
      type: Number,
      default: -1,
    },
    smallRoad: {
      type: Number,
      default: -1,
    },
    cockroachRoad: {
      type: Number,
      default: -1,
    },
  },
};
</script>
<style lang="scss" scoped>
.icons {
  display: flex;
  align-items: center;
  .forcast-icon-wrapper {
    width: 12px;
    height: 12px;
    margin-left: 3px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
